(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mx-card-controls"] && !Shopify.designMode) return;
  try {
    const modaXInitializedSelects = new WeakSet();
const modaXCardImages = new WeakMap();

function fitModaXCardSize(select) {
  if (!select) return;
  const actions = select.closest('.mx-card-actions');
  const field = select.closest('.mx-card-size-field');
  const label = field?.querySelector('.mx-card-selected-size');
  const option = select.selectedOptions[0];
  if (!actions || !field || !label || !option) return;
  const text = option.textContent.replace(/\s+/g, ' ').trim();
  const displayText = text.replace(/\b(?:women|woman|womens|women’s|women's)\b/gi, 'W').replace(/\b(?:men|mens|men’s|men's)\b/gi, 'M').replace(/\s*\/\s*/g, ' / ');
  if (label.textContent !== displayText) label.textContent = displayText;
  select.title = text;
}

function clearModaXCardError(form) {
  const feedback = form?.querySelector('[data-mx-card-error]');
  if (!feedback) return;
  feedback.hidden = true;
  feedback.textContent = '';
}

function hydrateModaXCardImage(select) {
  const form = select.closest('form');
  const option = select.selectedOptions[0];
  if (!form || !option?.dataset.imageKey) return;
  let images = modaXCardImages.get(form);
  if (!images) {
    const metadata = form.querySelector('[data-mx-card-image-data]');
    if (!metadata) return;
    try {
      images = JSON.parse(metadata.textContent);
      modaXCardImages.set(form, images);
    } catch {
      return;
    }
  }
  const image = images[option.dataset.imageKey];
  if (!image) return;
  option.dataset.image = image.src;
  option.dataset.srcset = image.srcset;
}

function syncModaXCard(select, updateImage = false) {
  fitModaXCardSize(select);
  if (!select.value) return;
  const option = select.selectedOptions[0];
  const form = select.closest('form');
  const card = select.closest('product-card');
  if (!form || !card || !option) return;
  const variantInput = form.querySelector('input[name="id"]');
  if (variantInput) variantInput.value = select.value;
  const button = form.querySelector('.mx-card-add');
  if (button) button.disabled = !select.value || option.disabled;
  const prices = card.querySelector('.price-list');
  if (prices && option.dataset.price) {
    const price = document.createElement('span');
    price.textContent = option.dataset.price;
    price.className = option.dataset.compare ? 'text-on-sale' : 'text-subdued';
    prices.replaceChildren(price);
    if (option.dataset.compare) {
      const compare = document.createElement('s');
      compare.textContent = option.dataset.compare;
      compare.className = 'text-subdued';
      prices.append(compare);
    }
  }
  const image = card.querySelector('.product-card__image--primary');
  if (updateImage && image && option.dataset.image) {
    image.src = option.dataset.image;
    image.srcset = option.dataset.srcset;
  }
  if (select.hasAttribute('data-mx-multicolor')) {
    if (option.dataset.variantUrl) {
      card.querySelectorAll('a.product-card__media, a.product-title, a.mx-wheel__title').forEach(link => {
        link.href = option.dataset.variantUrl;
      });
    }
    if (select.dataset.productHandle) {
      card.querySelectorAll('quick-buy-modal').forEach(modal => {
        modal.setAttribute('handle', `${select.dataset.productHandle}?variant=${select.value}`);
      });
    }
  }
}
document.addEventListener('change', (event) => {
  const select = event.target.closest('.mx-card-size');
  if (select) {
    hydrateModaXCardImage(select);
    clearModaXCardError(select.closest('form'));
    syncModaXCard(select, true);
  }
}, true);
document.addEventListener('submit', event => {
  if (event.target.matches('form.mx-card-form')) clearModaXCardError(event.target);
}, true);
document.addEventListener('cart:error', event => {
  const form = event.target.closest?.('form.mx-card-form');
  const feedback = form?.querySelector('[data-mx-card-error]');
  if (!feedback) return;
  const error = event.detail?.error || event.detail?.message;
  const message = typeof error === 'string' && error.trim() ? error : feedback.dataset.fallback;
  feedback.hidden = false;
  feedback.textContent = message;
});
document.addEventListener('variant:add', event => {
  const form = event.target.closest?.('form.mx-card-form');
  if (form) clearModaXCardError(form);
});
function initializeModaXCard(select) {
  if (modaXInitializedSelects.has(select)) return;
  modaXInitializedSelects.add(select);
  syncModaXCard(select);
}
if (!customElements.get('mx-card-size-field')) {
  customElements.define('mx-card-size-field', class extends HTMLElement {
    connectedCallback() {
      this.select = this.querySelector('.mx-card-size');
      this.actions = this.closest('.mx-card-actions');
      if (this.select) initializeModaXCard(this.select);
    }
    disconnectedCallback() {
      if (this.select) modaXInitializedSelects.delete(this.select);
      this.select = null;
      this.actions = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
